import { useGetLeaseBalanceQuery } from '@/store/api';

/**
 * Fetches the current balance for a lease using the dedicated balance endpoint.
 * Works for all PMS types (Yardi, Entrata, etc.) — the backend routes via PMSAdapterFactory.
 * Aligned with the web app's getTenantBalance / getResidentBalance pattern.
 */
export const usePaymentBalance = (leaseId: string) => {
  const leaseIdNum = Number(leaseId);

  const {
    data: balanceData,
    isLoading,
    error,
    refetch,
  } = useGetLeaseBalanceQuery(leaseIdNum, {
    skip: !leaseIdNum,
  });

  const balanceDue = Number(balanceData?.balanceDue || 0);

  return {
    balanceDue,
    isLoading,
    error,
    refreshBalance: refetch,
  };
};